import { useState } from 'react';

import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';
import type { Organization } from '../../../types';

import BackfillIssueSanitizedLocators from './BackfillIssueSanitizedLocators';
import BackfillLicenseIdentificationDataCard from './BackfillLicenseIdentificationDataCard';
import BackfillSBOMSummaryData from './BackfillSBOMSummaryData';
import { FullOrganizationPackageCacheRebuildCard } from './FullOrganizationPackageCacheRebuildCard';
import IssueCountBackfillCard from './IssueCountBackfillCard';
import ReanalyzeQuickImportCard from './ReanalyzeQuickImportCard';
import SyncPythonPackages from './SyncPythonPackages';

type Props = {
  org: Organization;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const BackfillCard = ({ org, isOpen, onToggle }: Props) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="backfill-org-data" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Backfill Org Data</Accordion.Target>
          <Accordion.Body>
            <Flex direction="column" gap={12}>
              <BackfillLicenseIdentificationDataCard />
              <BackfillSBOMSummaryData />
              <BackfillIssueSanitizedLocators />
              <IssueCountBackfillCard />
              <ReanalyzeQuickImportCard />
              <FullOrganizationPackageCacheRebuildCard org={org} />
              <SyncPythonPackages />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
